import type { FC, CSSProperties } from 'react';
import { useNavigate } from 'react-router-dom';

import NavBar from '@components/NavBar';

import './Header.scss';

type HeaderProps = {
  className?: string;
  sx?: CSSProperties;
};

const Header: FC<HeaderProps> = ({className = '', sx}) => {
    const navigate = useNavigate();
    const title = process.env.REACT_APP_TITLE || '';

    return (
        <header className={`header ${className}`} style={sx}>
            <div className="container-fluid">
                <div className="product-name" onClick={() => navigate('/dashboard')}>{title} ©</div>
                <NavBar />
            </div>
        </header>
    );
};

export default Header;
